import CircularProgress from "../../components/CircularProgress";
import CustomButton from "../../componentLibrary/TopicButton";
import { LessonI } from "../../types";

type LessonListProps = {
  lessons: LessonI[];
  moduleColor?: string;
  getLessonProgress: (lessonId: string, totalPages: number) => number;
  onClickLesson: (lessonId: string) => void;
};

const LessonList = ({
  lessons,
  moduleColor,
  getLessonProgress,
  onClickLesson,
}: LessonListProps) => {
  return (
    <div className="flex flex-col space-y-4 w-full">
      {lessons.map(({ _id, title, icon, pages }) => (
        <CustomButton
          key={_id}
          className="w-full"
          color={moduleColor}
          icon={
            <CircularProgress
              percentage={getLessonProgress(_id, pages.length)}
              icon={icon.src}
            />
          }
          onClick={() => onClickLesson(_id)}
          text={title}
        />
      ))}
    </div>
  );
};

export default LessonList;
